import { render } from "./DataSourceVideosTable.vue?vue&type=template&id=376a7156&ts=true"
import script from "./DataSourceVideosTable.vue?vue&type=script&lang=tsx"
export * from "./DataSourceVideosTable.vue?vue&type=script&lang=tsx"

import "./DataSourceVideosTable.vue?vue&type=style&index=0&id=376a7156&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__